import { parse } from "graphql";
const INBOX_ANNOUNCEMENT_PROPS = `
    acknowledge
    acknowledged
    announcementId
    backgroundColor
    created
    imageSource
    priority
    state
    summary
    targetPlatformType
    targetVersion
    template
`;
const EXTRA_ANNOUNCEMENT_PROPS = `
    body
    expires
    inboxPriority
    userName
`;
export const GET_INBOX_ANNOUNCEMENTS = parse(`
    query getInboxAnnouncements {
        getInboxAnnouncements {
            ${INBOX_ANNOUNCEMENT_PROPS}
            ${EXTRA_ANNOUNCEMENT_PROPS}
        }
    }
`);
export const ACKNOWLEDGE_ANNOUNCEMENT = parse(`
    mutation acknowledgeAnnouncement($announcementId: String!) {
        acknowledgeAnnouncement(announcementId: $announcementId) {
            ${INBOX_ANNOUNCEMENT_PROPS}
            ${EXTRA_ANNOUNCEMENT_PROPS}
        }
    }
    `);
export const DISMISS_ANNOUNCEMENT = parse(`
    mutation dismissAnnouncement($announcementId: String!) {
        dismissAnnouncement(announcementId: $announcementId) {
            ${INBOX_ANNOUNCEMENT_PROPS}
            ${EXTRA_ANNOUNCEMENT_PROPS}
        }
    }
    `);